import { isSameDay } from '@sequencehq/utils/dates'
import {
  RevenueClassification,
  RevenueRecognitionMethod,
  revenueRecognitionOptions
} from 'common/types/revenueRecognition.types'
import { match } from 'ts-pattern'

export const filterRevenueRecognitionOptions = (
  revenueClassification: RevenueClassification,
  servicePeriod?: { startDate: string | Date; endDate: string | Date }
) => {
  const validMethods = getValidRevenueRecognitionMethods(
    revenueClassification,
    servicePeriod
  )

  return revenueRecognitionOptions.filter(({ value }) =>
    validMethods.includes(value as RevenueRecognitionMethod)
  )
}

const hasValidServicePeriod = (servicePeriod?: {
  startDate: string | Date
  endDate: string | Date
}): servicePeriod is { startDate: string | Date; endDate: string | Date } =>
  Boolean(servicePeriod?.startDate && servicePeriod?.endDate)

export const getValidRevenueRecognitionMethods = (
  revenueClassification: RevenueClassification,
  servicePeriod?: { startDate: string | Date; endDate: string | Date }
): RevenueRecognitionMethod[] => {
  if (!hasValidServicePeriod(servicePeriod)) {
    return ['POINT_IN_TIME', 'USAGE']
  }

  return (
    match(revenueClassification)
      .with('EARNED', () => {
        const startDate =
          typeof servicePeriod.startDate === 'string'
            ? new Date(servicePeriod.startDate)
            : servicePeriod.startDate

        const endDate =
          typeof servicePeriod.endDate === 'string'
            ? new Date(servicePeriod.endDate)
            : servicePeriod.endDate

        if (!isSameDay(startDate, endDate)) {
          return ['STRAIGHT_LINE', 'USAGE'] as RevenueRecognitionMethod[]
        } else {
          return ['POINT_IN_TIME', 'USAGE'] as RevenueRecognitionMethod[]
        }
      })
      .with(
        'PREPAYMENT',
        () => ['MILESTONE', 'STRAIGHT_LINE'] as RevenueRecognitionMethod[]
      )
      // I don't think we use burndown in practice so we'll just return all values for now
      .with('BURNDOWN', () =>
        revenueRecognitionOptions.map(({ value }) => value)
      )
      .exhaustive()
  )
}
